'use strict';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class SixGrid {
    static init() {
        $('.module-6-grid').each((index, el) => {
            new SixGrid($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        const self = this;
        // this.oldWindowWidth = $(window).width();
        // $(window).on('resize', this.onResize.bind(this));
        const swiper = new Swiper('#' + this.el.find('.module-6-grid-mobile').attr('id'), {
            modules: [Navigation],
            slidesPerView: 1.2,
            spaceBetween: 30,
            navigation: {
                prevEl: self.el.find('.module-6-grid-mobile-prev').get(0),
                nextEl: self.el.find('.module-6-grid-mobile-next').get(0)
            }
        });
    }

    onResize(e) {
        if ($(window).width() > 768 && this.oldWindowWidth <= 767) {

        }
    }
}